import React from 'react'

const Leaflet: React.FC = () => {
  return (
    <img style={{position: "relative", height: "100%", pointerEvents: "none", userSelect: "none"}} src="/svgs/leaflet.svg" alt="leaflet"/>
  )
}

export default Leaflet